import React from 'react';
import SidebarContent from './components/SidebarContent';

type Props = {
  className?: string;
  duration: number;
  side: 'left' | 'right';
  onClose: () => void;
  children: React.ReactNode;
};

const SideSlideAnimation = ({
  side,
  onClose,
  duration,
  className,
  children,
}: Props) => {
  return (
    <SidebarContent
      side={side}
      onClose={onClose}
      duration={duration}
      className={className}
      key='key'
    >
      {children}
    </SidebarContent>
  );
};

export default SideSlideAnimation;
